import { App } from 'vue';
import { v4 as uuidv4 } from 'uuid';

export default ({ app }: { app: App<any> }) => {
  // 进入页面执行
  // 记录当前时间并转成时间戳
  const now = new Date().getTime();
  // 从缓存中获取用户上次退出的时间戳
  const leaveTime = parseInt(localStorage.getItem('leaveTime')!, 10);
  // 判断是否为刷新，两次间隔在5s内判定为刷新操作
  const refresh = (now - leaveTime) <= 5000;
  let uuid = localStorage.getItem('uuid')
  if (refresh && uuid) {
    app.provide('uuid', uuid)
  } else {
    uuid = uuidv4()
    app.provide('uuid', uuid)
    localStorage.setItem('uuid', uuid)
  }
}
